import styled from 'styled-components'
import { useTranslation } from "react-i18next"

const Container = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 24px 44px;
`

const PVTSetting = () => {
  const { t } = useTranslation('common')
  return (
    <Container>
      <span style={{ fontSize: 28, fontWeight: 700, marginBottom: 8 }}>
        {t('pvt.preparing')}
      </span>
    </Container>
  )
}

export default PVTSetting
